import { CommonModule } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, Inject, signal } from "@angular/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { CBox_PreInvoiceListItem } from "@server/services/cbox/public/api/v1/resources/financial/pre_invoices/types";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ApiService, handlePublicApiError } from "src/services/api/api.service";
import { ToastService } from "src/services/toast/toast.service";

@Component({
  selector: "app-cbox-finance-pre-invoice-approve-dialog",
  templateUrl: "./cbox-finance-pre-invoice-approve-dialog.component.html",
  styleUrls: ["./cbox-finance-pre-invoice-approve-dialog.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    // Angular Material
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,

    // PrimeNG
    ButtonModule,
    InputTextModule,
    ProgressSpinnerModule
  ]
})

export class CBoxFinancePreInvoiceApproveDialogComponent {

  loading = signal(false);

  constructor(
    private toastService: ToastService,
    private api: ApiService,
    private dialogRef: MatDialogRef<CBoxFinancePreInvoiceApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public preInvoice: CBox_PreInvoiceListItem) { }

  approve(): void {
    this.loading.set(true);

    this.api.patch(`backend/financial/pre-invoices/${this.preInvoice.identifier}/status`, {
      status: "APPROVED",
    }).subscribe(() => {
      this.toastService.showSuccessToast("Confirmare", "Borderoul a fost acceptat cu succes!");
      this.dialogRef.close();
    }, (e: HttpErrorResponse) => {
      this.loading.set(false);
      handlePublicApiError(e, this.toastService);
    });
  }
}